import { render, staticRenderFns } from "./NewsWidgetResponsive.vue?vue&type=template&id=9cd19638&"
import script from "./NewsWidgetResponsive.vue?vue&type=script&lang=js&"
export * from "./NewsWidgetResponsive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports